import React from "react";
import "./AppTopbar.css";

export const AppTopbar = (props) => {
  return (
    <div className="layout-topbar clearfix" style={{ display: "flex", alignItems: "center" }}>
      <button type="button" className="layout-menu-button menu-link" onClick={props.onToggleMenu}>
        {/* <span className="pi pi-bars" /> */}
        <div className={`menu-btn ${props.isSidebarVisible ? "open" : ""}`}>
          <div className="menu-burger"></div>
        </div>
      </button>
      <label style={{ fontSize: "18px", fontWeight: 600, marginLeft: "auto" }}>
        {"MONITORA"} - {process.env.REACT_APP_AMBIENTE}
      </label>
    </div>
  );
};
